<template>
  <div class="Shopdecoration">
    <div class="header">
      <div class="divs">
        <div class="fz18">{{ $t('StoreConstruction.construction') }}</div>
      </div>
    </div>
    <div class="main">
      <!-- 店铺顶部图片 -->
      <div class="main-t">
        <div class="spans">
          <!-- <span class="iconfont icon-a-ziyuan11"></span> -->
          <span class="p">{{ $t('StoreConstruction.top') }}</span>
        </div>
        <div class="spanbtn">
          <span style="font-size: 12px"
            >{{ $t('StoreConstruction.system') }}</span
          >
          <div class="span-bor">
            <div v-if="logoTop.url" class="box">
              <Icon
                type="md-close-circle"
                size="23"
                color="#e90d0d"
                @click="delLogo"
                v-has="'WSS-3002-edit'"
              />
              <img :src="logoTop.url" alt="" />
            </div>
            <upload
              v-show="this.y"
              :options="options1"
              style="display: inline-block"
              @getOssRes="getheadpiece"
              v-has="'WSS-3002-edit'"
            ></upload>
            <!-- <div class="span-bor-icon" v-else>
              <Icon type="md-add"
               />
              <p>图片尺寸1200*100</p>
            </div> -->
          </div>
          <!-- <upload
            :options="options1"
            style="display: inline-block"
            @getOssRes="getLogTop"
            v-has="'WSS-3002-edit'"
          ></upload>
          <span style="font-size: 12px"
            >系统会根据上传图片自动调整，可能造成变形。推荐尺寸：1200*100</span
          >
        </div>
        <div class="span-bor">
          <div v-if="logoTop.url" class="box">
            <Icon
              type="md-close-circle"
              size="23"
              color="#e90d0d"
              @click="delLogo"
              v-has="'WSS-3002-edit'"
            />
            <img :src="logoTop.url" alt="" />
          </div>
          <div class="span-bor-icon" v-else>
            <Icon type="md-add" />
            <p>图片尺寸1200*100</p>
          </div>-->
        </div>
      </div>
      <!-- 店铺照片 -->
      <div class="main-c">
        <div class="spans">
          <!-- <span class="iconfont icon-a-ziyuan11"></span> -->
          <span class="p">{{ $t('StoreConstruction.photo') }}</span>
        </div>
        <p class="pp">{{ $t('StoreConstruction.maximum') }}</p>
        <div class="img">
          <div v-for="item in imgs" :key="item.id" class="imgs">
            <!-- <template> -->
            <img :src="item.url" />
            <Icon
              type="md-close-circle"
              size="23"
              @click="delimgs(item.id)"
              v-has="'WSS-3002-edit'"
            />
            <!-- </template> -->
          </div>
          <upload
            :options="options2"
            @getOssRes="getImgs"
            v-has="'WSS-3002-edit'"
          ></upload>
        </div>
      </div>
      <!-- 公司介绍 -->
      <div class="main-b">
        <div class="spans">
          <!-- <span class="iconfont icon-gongsi"></span> -->
          <span class="p">{{ $t('StoreConstruction.Store') }}</span>
        </div>
        <Button type="error" v-show="!SHow" @click="btnOK">{{ $t('StoreConstruction.Finish') }}</Button>
        <Button
          type="error"
          v-show="SHow"
          @click="SHow = false"
          v-has="'WSS-3002-edit'"
          >{{ $t('StoreConstruction.edit') }}</Button
        >
        <div class="quill-div" v-show="!SHow">
          <upload
            id="upload"
            :options="options"
            @getOssRes="getOssRes"
            ref="uploadify"
          ></upload>
          <quill-editor
            v-model="description.content"
            ref="editor"
            :options="editorOption"
          >
          </quill-editor>
        </div>
        <!-- 富文本渲染 -->
        <div class="showhtml" v-show="SHow">
          <div v-html="html">{{ $t('StoreConstruction.company') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '../../base/uploadify/upload.vue'
import {
  getTenantMessage,
  updateTenantMessage,
  updatedesc,
  delimgs
} from '@/api/myweb/shopmanagement/Shopdecoration.js'
// 富文本工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'strike'], // 加粗 斜体 下划线 删除线
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  ['link', 'image'], // 链接、图片、视频
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ align: [] }] // 对齐方式
]
export default {
  name: 'Shopdecoration',
  components: { upload },
  data() {
    return {
      options1: {
        headpiece: true,
        size: 6,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      options2: {
        size: 6,
        imgs: true,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ]
      },
      options: {
        size: 6,
        optionbtn: false,
        optionbtn1: false,
        edit: true,
        fileType: ['jpg', 'png', 'jpeg', 'psd', 'gif', 'bmp']
      },
      logoTop: {}, // 店铺logo
      imgs: [], // 店铺图片
      headpiece: [],
      description: {}, // 富文本
      html: '', // 富文本渲染
      SHow: true, // 富文本显示
      editorOption: {
        placeholder: '请编辑好公司的情况...',
        theme: 'snow', // 默认主题
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#upload .ivu-icon').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      y: null
    }
  },
  created() {
    this.getshopInformations()
  },
  methods: {
    // 获取店铺信息
    async getshopInformations() {
      const res = await getTenantMessage()
      console.log('店铺信息', res)
      if (res.status) {
        this.logoTop = res.data.logoTop
        this.description = res.data.description
        this.html = res.data.description.content
        this.imgs = res.data.imgs
      }
      if (this.logoTop.id) {
        this.y = false
      } else {
        this.y = true
      }
    },
    // 上传logo
    async getheadpiece(data) {
      if (data.res.statusCode == 200) {
        const res = await updateTenantMessage({
          logoTop: encodeURIComponent(data.url)
        })
        if (res.status) {
          this.getshopInformations()
          this.$Message.success('上传成功')
        }
      }
    },
    // 上传店铺图片
    async getImgs(data) {
      if (this.imgs.length > 4) {
        this.$Message.warning('最多添加5张照片')
      } else {
        if (data.res.statusCode == 200) {
          const res = await updateTenantMessage({
            imgs: encodeURIComponent(data.url)
          })
          if (res.status) {
            this.getshopInformations()
            this.$Message.success('上传成功')
          }
        }
      }
    },
    // 删除LOGO
    delLogo() {
      this.$Modal.confirm({
        title: '是否删除该Logo',
        onOk: async () => {
          const res = await delimgs({
            id: this.logoTop.id
          })
          if (res.status) {
            this.getshopInformations()
            this.$Message.success('删除成功')
          }
        },
        onCancel: () => {}
      })
    },
    // 删除店铺照片
    delimgs(id) {
      console.log(id)
      this.$Modal.confirm({
        title: '是否删除该图片',
        onOk: async () => {
          const res = await delimgs({
            id: id
          })
          if (res.status) {
            this.getshopInformations()
            this.$Message.success('删除成功')
          }
        },
        onCancel: () => {}
      })
    },
    // 保存厂商介绍
    async btnOK() {
      const res = await updatedesc({
        description: this.description.content,
        descId: this.description.id
      })
      if (res.status) {
        this.SHow = true
        this.getshopInformations()
        this.$Message.success('保存成功')
      }
    },
    // 富文本图片
    getOssRes(res) {
      console.log(res)
      let quill = this.$refs.editor.quill
      let length = quill.getLength()
      quill.insertEmbed(length, 'image', res.url)
      quill.setSelection(length + 1)
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
.Shopdecoration {
  // margin-top: 40px;
  // margin-top: 30px;
  .header {
    width: 100%;
    height: 60px;
    background: #ffffff;
    box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
    opacity: 1;
    border-radius: 0px;
    padding-left: 19px;
    padding-top: 22px;
    .divs {
      width: 380px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;
      color: #505050;
      .fz18 {
        line-height: 16px;
      }
    }
  }
  .main {
    margin-top: 10px;
    height: 100%;
    min-height: 750px;
    background: #ffffff;
    // box-shadow: 2px 2px 10px 3px rgba(104, 104, 104, 0.1);
    box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
    padding: 20px;
    .spans {
      padding-bottom: 3px;
      border-bottom: 1px solid #e2e2e2;
      .iconfont {
        font-size: 16px;
        color: #919191;
      }
      .p {
        font-size: 18px;
        font-weight: bold;
        color: #555555;
        padding-left: 1px;
      }
    }
    .main-t {
      .spanbtn {
        // margin-top: 34px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 14px;
        // .ivu-upload {
        //   display: inline-block;
        // }
        /deep/ .ivu-btn {
          width: 80px;
          height: 30px;
          line-height: 27px;
          text-align: center;
          padding: 0;
          span {
            font-size: 16px;
          }
        }
        span {
          color: #c2c2c2;
          // padding-left: 8px;
          padding-bottom: 0;
        }
      }
      .span-bor {
        margin-top: 10px;
        height: 100px;
        // line-height: 100px;
        .span-bor-icon {
          // height: 100px;
          width: 100%;
          height: 100%;
          border: 1px dashed #d8d8d8;
          text-align: center;
          // line-height: 100px;
          .ivu-icon-md-add {
            margin-top: 30px;
            font-size: 30px;
            color: #c1c1c1;
          }
          p {
            font-size: 14px;
            color: #c2c2c2;
          }
        }
        .box {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            // background-position: center;
            // background-size: cover;
            // background-repeat: no-repeat;
            width: 100%;
            height: 100%;
          }
          // 删除图标
          .ivu-icon-md-close-circle {
            cursor: pointer;
            position: absolute;
            right: -13px;
            top: -16px;
            // z-index: 99;
          }
        }
      }
    }
    .main-c {
      // margin: 60px 0 66px 0;
      margin: 24px 0 24px 0;
      .pp {
        // font-size: 14px;
        font-size: 12px;
        color: #c2c2c2;
        // margin-top: 50px;
        margin-top: 10px;
        margin-bottom: 20px;
      }
      .img {
        display: flex;
        .imgs {
          position: relative;
          // margin: 0 14px;
          // margin-left: 0;
        }
        img {
          width: 100px;
          height: 100px;
          margin: 0 14px;
          margin-left: 0;
        }
        .ivu-icon-md-close-circle {
          color: #e90d0d;
          position: absolute;
          right: 1px;
          top: -11px;
          cursor: pointer;
          // z-index: 100;
        }
      }
      .upload {
        margin-left: 16px;
        cursor: pointer;
        div {
          width: 100px;
          height: 100px;
          display: flex;
          flex-flow: column;
          .ivu-icon-md-add {
            padding-top: 40px;
          }
          // line-height: 100px;
          .icon-p {
            font-size: 14px;
            color: #c2c2c2;
            cursor: pointer;
            padding-top: 10px;
          }
        }
      }
    }
    .main-b {
      /deep/ .ivu-btn {
        // margin-top: 34px;
        margin-top: 10px;
        margin-bottom: 6px;
        width: 80px;
        height: 30px;
        line-height: 27px;
        text-align: center;
        padding: 0;
        span {
          font-size: 16px;
        }
      }
      .quill-div {
        // height: 500px;
        height: 330px;
        #upload {
          display: none;
        }
        .quill-editor {
          position: relative;
          // margin: 2px 5px;
          height: 300px;
          // overflow-y: auto;
        }
      }
      .showhtml {
        /deep/ img {
          margin: 0 auto !important;
          border-style: none;
          max-width: 1000px;
        }
        height: 300px;
        overflow-y: auto;
        border: 1px solid #b5b5b5;
        padding: 5px;
      }
    }
  }
}
//店铺顶部图片上次图片按钮颜色
.Shopdecoration /deep/.main .main-t .spanbtn .ivu-btn {
  background: #377cf1 !important;
  border: 1px solid #377cf1;
}
//店铺介绍按钮颜色
.Shopdecoration .main .main-b .ivu-btn {
  background: #377cf1 !important;
  border: 1px solid #377cf1;
}
//店铺顶部图片上次图片按钮字体
.Shopdecoration /deep/.main .main-t .spanbtn .ivu-btn span {
  font-size: 14px;
}
//店铺介绍按钮字体
.Shopdecoration /deep/.main .main-b .ivu-btn span {
  font-size: 14px;
}
//店铺头部字体
.Shopdecoration .main .spans .p {
  font-size: 16px;
  font-weight: bold;
  color: #555555;
  padding-left: 1px;
}
//店铺介绍富文本编辑器保存后文字大小
.Shopdecoration /deep/.showhtml p {
  font-size: 12px;
}
.Shopdecoration /deep/.ql-editor p {
  font-size: 12px;
}
</style>
